import dynamic from "next/dynamic";

import {
  apstagBidCallback,
  createApsSlotsRosDesktop,
  createApsSlotsRosMobile,
  requestBiddingFromPWT,
} from "@/utils/ads";

import { useRouter } from "next/router";
import { useContext, useEffect, useState } from "react";
import IPLSponsor from "@/component/IPL/IPLSponser";
import { MasterConfigContext } from "@/context/MasterConfigContext";
const AdSlot300x250 = dynamic(() => import("@/component/Ads/AdSlot300x250"));
const AdSlot728x90 = dynamic(() => import("@/component/Ads/AdSlot728x90"));
const MGIDAAdsScript = dynamic(() => import("@/component/Ads/MGIDAdsScript"));
const IPLMenu = dynamic(() => import("@/component/IPL/IPLMenu"));
const IPLCommonFooter = dynamic(() =>
  import("@/component/IPL/IPLCommonFooter")
);
const HeadTag = dynamic(() => import("@/component/SeoTags/HeadTag"));
const GTMScript = dynamic(() => import("@/component/Ads/GTMScript"));
const Breadcrumb = dynamic(() => import("@/component/Breadcrumb"));
const BreadcrumbSchema = dynamic(() =>
  import("@/component/SeoTags/BreadcrumbSchema")
);
const ItemsList = dynamic(() => import("@/component/SeoTags/ItemsList"));
const WebpageSchema = dynamic(() =>
  import("@/component/SeoTags/WebpageSchema")
);
// const WebsiteSchema = dynamic(() =>
//   import("@/component/SeoTags/WebsiteSchema")
// );
// const IPLFAQSchema = dynamic(() => import("@/component/SeoTags/IPLFAQSchema"));

const PointsPage = ({
  categoryNewsListData = null,
  isMobileDevice = false,
  faqData = null,
  pointsData = null,
}) => {
  const router = useRouter();
  const currentPath = router?.asPath?.split("?")[0];
  const keyBindings = {
    Category:
      currentPath.split("/").length > 2
        ? [currentPath.split("/")[1], currentPath.split("/")[2]]
        : currentPath.split("/")[1],
    Keywords: categoryNewsListData?.seo_detail?.meta_keyword.split(","),
  };
  const [readMore, setReadMore] = useState(true);
  const [scrolled, setScrolled] = useState(true);
  // useEffect(() => {
  //   async function onFirstScroll() {
  //     if (!scrolled) {
  //       setScrolled(true);
  //     }
  //   }

  //   function handleScroll() {
  //     onFirstScroll();

  //     window.removeEventListener("scroll", handleScroll);
  //   }

  //   window.addEventListener("scroll", handleScroll);
  // }, []);
  // ads

  useEffect(() => {
    setTimeout(() => {
      window.googletag = window.googletag || { cmd: [] };

      if (window.screen.width < 900) {
        googletag.cmd.push(function () {
          if (scrolled) {
            googletag.destroySlots();
            googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_ROS_ATF_300x250",
                [300, 250],
                "div-gpt-ad-1659434453897-0"
              )
              .addService(googletag.pubads());
          }

          if (scrolled) {
            googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_ROS_MTF_1_300x250",
                [300, 250],
                "div-gpt-ad-1659434604998-0"
              )
              .addService(googletag.pubads());

            googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_ROS_MTF-2_300x250",
                [300, 250],
                "div-gpt-ad-1659434785315-0"
              )
              .addService(googletag.pubads());

            googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_ROS_BTF_300x250",
                [300, 250],
                "div-gpt-ad-1659435474737-0"
              )
              .addService(googletag.pubads());
          }
          scrolled &&
            googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_ROS_Bottom_320x50",
                [320, 50],
                "div-gpt-ad-1659435612077-0"
              )
              .addService(googletag.pubads());

          // googletag.pubads().enableSingleRequest();
          // googletag.pubads().disableInitialLoad();
          googletag.enableServices();
          requestBiddingFromPWT();
          googletag.setConfig({ disableInitialLoad: true, targeting: keyBindings });
          scrolled &&
            googletag?.cmd.push(function () {
              var INTERSTITIALAd = googletag
                ?.defineOutOfPageSlot(
                  "/1007232/News_tak_Mobile_HP_Mweb_Interstitial",
                  googletag?.enums.OutOfPageFormat.INTERSTITIAL
                )
                ?.addService(googletag.pubads());
              INTERSTITIALAd && googletag?.display(INTERSTITIALAd);
            });
        });
      } else {
        googletag.cmd.push(function () {
          if (scrolled) {
            googletag.destroySlots();
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_ATF_728x90",
                [728, 90],
                "div-gpt-ad-1659424515060-0"
              )
              .addService(googletag.pubads());
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_ATF_300x250",
                [300, 250],
                "div-gpt-ad-1707804176041-1"
              )
              .addService(googletag.pubads());
          }

          if (scrolled) {
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_MTF_1_728x90",
                [728, 90],
                "div-gpt-ad-1707804176041-2"
              )
              .addService(googletag.pubads());
            document.getElementById("div-gpt-ad-1707804176041-3") &&
              googletag
                .defineSlot(
                  "/1007232/News_tak_Desktop_ROS_MTF_2_728x90",
                  [728, 90],
                  "div-gpt-ad-1707804176041-3"
                )
                ?.addService(googletag.pubads());
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_BTF_728x90",
                [728, 90],
                "div-gpt-ad-1659425743360-0"
              )
              .addService(googletag.pubads());
          }

          // googletag.pubads().enableSingleRequest();
          // googletag.pubads().disableInitialLoad();
          googletag.enableServices();
          requestBiddingFromPWT();
          googletag.setConfig({ disableInitialLoad: true, targeting: keyBindings });
        });
      }
      if (scrolled) {
        apstag?.fetchBids(
          {
            slots:
              window.screen.width < 900
                ? createApsSlotsRosMobile({ mtf2: false, mtf3: false })
                : createApsSlotsRosDesktop({ mtf2: false, mtf3: false }),
            timeout: 2e3,
          },
          apstagBidCallback
        );
      }
    }, 10);
  }, [scrolled]);
  const masterConfig = useContext(MasterConfigContext);
  const iplKeys = masterConfig["ipl_2025"];

  const title =
    "IPL 2025 Points Table: Updated Team Rankings, Wins, Net Run Rate & Standings - NewsTak";
  const description =
    "Check the latest IPL 2025 Points Table with team rankings, matches played, wins, losses, and Net Run Rate updates. Get real-time rankings after every match.";
  const keywords =
    "IPL 2025 Points Table, IPL 2025 Team Rankings, IPL 2025 Standings, IPL 2025 Live Points Table, IPL 2025 NRR, IPL 2025 Match Results, IPL 2025 Today Points Table, IPL 2025 Updated Table";
  const canonical = "/sports/ipl/points-table";

  const breadCrumbs = [
    {
      id: "1",
      title: "Sports",
      canonical_url: "/sports",
      amp_url: "",
    },
    {
      id: "2",
      title: "IPL",
      canonical_url: "/sports/ipl",
      amp_url: "",
    },
    {
      id: "3",
      title: "Points Table",
      canonical_url: "/sports/ipl/points-table",
      amp_url: "",
    },
  ];

  return (
    <div>
      <HeadTag
        title={title}
        description={description}
        keywords={keywords}
        canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + canonical}
        noAuthorTag={false}
        image={categoryNewsListData?.seo_detail?.og_image}
        lcpImage={`${categoryNewsListData?.content?.[0]?.image_small}?size=360:203`}
      />
      <GTMScript isElection={true} />
      {/* <WebsiteSchema /> */}
      {/* <IPLFAQSchema /> */}
      <WebpageSchema
        title={title}
        description={description}
        keywords={keywords}
        canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + canonical}
      />
      <BreadcrumbSchema breadcrumbList={breadCrumbs} />

      <ItemsList
        data={
          categoryNewsListData?.length > 0
            ? [...categoryNewsListData?.content]
            : []
        }
      />
      <Breadcrumb breadcrumbList={breadCrumbs} />
      <MGIDAAdsScript delay={true} />
      <div className="mx-4">
        <AdSlot300x250
          divId="div-gpt-ad-1659434453897-0"
          minWidth="300px"
          minHeight="250px"
        />

        <AdSlot728x90
          divId="div-gpt-ad-1659424515060-0"
          minWidth="728px"
          minHeight="90px"
        />
      </div>

      {iplKeys?.showSponsor && (
        <IPLSponsor color="white" masterConfigKey={iplKeys} />
      )}
      <IPLMenu />
      <section className="px-4 py-2">
        <h1 className="my-4 font-semibold text-lg">IPL 2025 Point Table</h1>
        <p className={`text-[#323232] text-sm text-left relative inline`}>
          <span className={`${readMore ? "line-clamp-2" : ""}`}>
            IPL के हर मैच के बाद सभी लोगों में एक्साइटमेंट होता है कि वो यह जाने
            की कौन सी टीम किस स्थान पर है. इसके लिए हमारे साथ जुडे रहें. यहां से
            IPL की पॉइंसटेबल की हर जानकारी पाए. जाने किस टीम ने कितने मैच
            खेले,कितने जीते, कितने हारे, कितने टाई हुए, और उनका नेट रन रेट क्या
            चल रहा है. यहां आपको IPL से जुड़ी अन्य मजेदार और क्विक जानकारियां भी
            मिलेंगी.
          </span>
          <span
            onClick={() => {
              setReadMore(prev => !prev);
            }}
            className="cursor-pointer inline -ml-[0.5px]  text-primary text-sm"
          >
            {readMore ? "और देखें >" : "< कम देखें"}
          </span>
        </p>

        {pointsData && (
          <div className="flex flex-col w-full gap-0 my-8">
            <div className="bg-[#0000001A] flex justify-between items-center w-full py-2 px-4 rounded-t-lg">
              <div className="w-[40%] md:w-[50%] text-sm">Teams</div>
              <div className="w-[60%] md:w-[50%] text-sm flex justify-end items-center gap-4 md:gap-8">
                <div className="w-[10%]">P</div>
                <div className="w-[10%]">W</div>
                <div className="w-[10%]">L</div>
                <div className="w-[10%]">D</div>
                <div className="w-[10%]">NR</div>
                <div className="w-[20%]">NRR</div>
                <div className="w-[10%]">Pts</div>
              </div>
            </div>
            {pointsData?.map((item, index) => {
              return (
                <div
                  key={index}
                  className={`flex items-center py-2 px-4 ${index % 2 == 0 ? "bg-white" : "bg-[#F8F9FB]"
                    }`}
                >
                  <div className="w-[40%] md:w-[50%] flex items-center gap-1">
                    <img
                      width={24}
                      height={24}
                      alt="point_team"
                      src={` https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/${item?.short_name?.toLowerCase()}.png`}
                    />
                    <span className="text-sm">{item?.short_name || "RCB"}</span>
                  </div>
                  <div className="w-[60%] md:w-[50%] text-sm flex justify-end items-center gap-4 md:gap-8">
                    <div className="w-[20%]">
                      <span>{item?.p || 0}</span>
                    </div>
                    <div className="w-[20%]">
                      <span>{item?.w || 0}</span>
                    </div>
                    <div className="w-[20%]">
                      <span>{item?.l || 0}</span>
                    </div>
                    <div className="w-[20%]">
                      <span>{item?.t || 0}</span>
                    </div>
                    <div className="w-[20%]">
                      <span>{item?.nr || 0}</span>
                    </div>
                    <div className="w-[40%]">
                      <span>{item?.nrr || "-"}</span>
                    </div>
                    <div className="w-[20%]">
                      <span>{item?.pts || 0}</span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
        {scrolled && (
          <AdSlot300x250
            divId={"div-gpt-ad-1659434604998-0"}
            minWidth="300px"
            minHeight="250px"
          />
        )}

        {scrolled && (
          <AdSlot728x90
            divId={"div-gpt-ad-1707804176041-2"}
            minWidth="720px"
            minHeight="90px"
          />
        )}
        <IPLCommonFooter
          categoryNewsListData={categoryNewsListData}
          faqData={faqData}
          isMobileDevice={isMobileDevice}
          showAds={true}
          scrolled={scrolled}
        />

        {scrolled && (
          <AdSlot300x250
            divId={"div-gpt-ad-1659435474737-0"}
            minWidth="300px"
            minHeight="250px"
          />
        )}

        {scrolled && (
          <AdSlot728x90
            divId="div-gpt-ad-1659425743360-0"
            minWidth="720px"
            minHeight="90px"
          />
        )}
        <div data-type="_mgwidget" data-widget-id="1584885"></div>
        <script
          async
          dangerouslySetInnerHTML={{
            __html: `window.addEventListener("load", function() {
          (function(w,q){w[q]=w[q]||[];w[q].push(["_mgc.load"])})(window,"_mgq");
        });`,
          }}
        ></script>
      </section>
    </div>
  );
};

export default PointsPage;
